import axios from 'axios';

const getYears = async function weekendsServiceGetYears () {
  const response = await axios.get('/api/settings/weekends/years');

  return response.data.data;
};

const getByYear = async function weekendsServiceGetByYear (year) {
  const response = await axios.get(`/api/settings/weekends/${year}`);

  return response.data.data;
};

const create = async function weekendsServiceCreate (data) {
  const response = await axios.post('/api/settings/weekends/', data);

  return response.data.data;
};

const update = async function dweekendsServiceUpdate (id, data) {
  const response = await axios.put(`/api/settings/weekends/${id}`, data);

  return response.data.data;
};

export default {
  getYears,
  getByYear,
  create,
  update,
};
